import { Component, OnInit } from '@angular/core';
import { ProyectosService, tipo_proyecto, tipo_financiacion } from '../../services/proyectos.service';
import { Project, TipoProyecto, TipoFinanciacion } from '../../../../../../interfaces/recursos/projects.entity';
import { ApplicationStore } from '../../../../../../shared/state/store/index';
import { Store } from '@ngrx/store';
import { loadingAction } from '../../../../../../shared/state/actions/loading.action';
import { validateSubRole } from '../../../../../../utils/role';
import { ConfirmDialogComponent } from '../../../../../../components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { showAlert } from '../../../../../../utils/alert';
import { TablePagination } from '../../../../../../utils/class/table-pagination.class';
import { IdNameType } from '../../../../../../constants/types';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

type FiltersType = {
	name?: string;
	tipo_financiacion?: 'regalias' | 'recursosPropios';
	tipo_proyecto?: 'contrato' | 'convenio';
}

@Component({
	selector: 'app-page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss'],
})
export class PageComponent extends TablePagination<Project> implements OnInit {
	canCreate = false;
	displayedColumns: string[] = [
		'nombre',
		'tipo_proyecto',
		'tipo_financiacion',
		'descripcion',
	];
	dialogSubscription = new Subscription();
	list_tipos_proyecto: IdNameType[] = [];
	list_tipo_financiacion: IdNameType[] = [];

	filtersForm: FormGroup = this.fb.group({
		name: new FormControl(''),
		tipo_financiacion: new FormControl(''),
		tipo_proyecto: new FormControl(''),
	});
	originalData: Project[] = [];

	constructor(
		private serviceProyects: ProyectosService,
		private store: Store<ApplicationStore>,
		private dialog: MatDialog,
		private fb: FormBuilder
	) {
		super([]);
	}

	ngOnInit(): void {
		this.list_tipos_proyecto = tipo_proyecto;
		this.list_tipo_financiacion = tipo_financiacion;

		this.filtersForm.valueChanges.subscribe(changes => {
			this.applyFilters(changes);
		});

		this.store.dispatch(loadingAction({ loading: true }));

		this.serviceProyects.getProjects().subscribe((projects) => {
			this.setData(projects);
			this.originalData = projects;

			this.canCreate = validateSubRole('projects', null, 'create');
			if (this.canCreate) {
				this.displayedColumns.push('actions');
			}
			this.store.dispatch(loadingAction({ loading: false }));
		});
	}

	applyFilters(filters: FiltersType) {
		const dataFiltered = [...this.originalData].filter(project => {
			let name = true;
			let tipoFin = true;
			let tipoPro = true;
			if (filters.name) {
				name = project.name?.toLowerCase().trim().includes(filters.name.toLowerCase().trim()) ?? false;
			}
			if (filters.tipo_financiacion) {
				tipoFin = project.funding_type === TipoFinanciacion[filters.tipo_financiacion];
			}
			if (filters.tipo_proyecto) {
				tipoPro = project.type === TipoProyecto[filters.tipo_proyecto];
			}
			return name && tipoFin && tipoPro;
		});

		this.setData([...dataFiltered]);
	}

	getTipoProyecto(value: number) {
		return tipo_proyecto.find(t => t.id === TipoProyecto[value])?.name ?? '';
	}

	getTipoFinanciacion(value: number) {
		return tipo_financiacion.find(t => t.id === TipoFinanciacion[value])?.name ?? '';
	}

	confirm(projectId: string) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '350px',
			autoFocus: false,
			data: {
				title: 'Eliminar proyecto',
				subtitle: '¿Está seguro de eliminar el proyecto? Esta acción es irreversible'
			}
		});

		this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
			if (result) {
				// Delete institution
				this.store.dispatch(loadingAction({ loading: true }));

				this.serviceProyects.delete(projectId).subscribe(() => {
					this.store.dispatch(loadingAction({ loading: false }));

					const newData = [...this.originalData.filter(i => i.id !== projectId)];
					this.originalData = newData;
					this.applyFilters(this.filtersForm.value);
					showAlert('Proyecto eliminado');
				});
			}
		});
	}
}
